// icons
import { Icon, IconProps } from '@iconify/react';

export default function Iconify(props: IconProps) {
  return <Icon {...props} />;
}
